import {
  setAllUsers,
  setAllWebsites,
  setDisplayErrorSnackBar,
} from "../../../features/userSlice";
import { actionItemsService } from "../../../services/api/action-items.endpoints";
import store from "../../../store";
import {
  setActionItemsList,
  setSingleactionItemDetails,
} from "../../../features/actionItemsSlice";

async function getAllActionItems(
  selectedSharedUid: any,
  oauthTokenHeader: string,
  dispatch: any
) {
  try {
    const response = await actionItemsService.getAllActionItemsList(
      oauthTokenHeader,
      selectedSharedUid
    );
    if (response.status === 204) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "No Action Items found",
          type: "warning",
        })
      );
      return;
    }
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get action items list");
    } else {
      dispatch(setActionItemsList(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function changeActionTaskStatus(oauthTokenHeader: any, data: any) {
  try {
    const response = await actionItemsService.updateActionTaskStatus(
      oauthTokenHeader,
      data
    );
    if (!response || !response.status) {
      throw new Error("Failed to update the task. Please try again later.");
    } else if (response.status === 207 || response.status === 200) {
      //store.dispatch(setDisplayErrorSnackBar({ message: "Current status has been updated", type: 'success' }))
      return response?.data;
    }
  } catch (e: any) {
    const message = { reason: "Unknown error occurred." }; // custom message for error handling
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );

    return e ? e?.parsedText : message;
  }
}

async function commentActionItemsTask(
  oauthTokenHeader: any,
  data: any,
  objectSharedUid: any
) {
  try {
    const response = await actionItemsService.postComment(oauthTokenHeader,data,objectSharedUid);
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to post comment action items");
    } else {
      //store.dispatch(setDisplayErrorSnackBar({ message: "Comment has been updated", type: 'success' }))
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getCommentsForActionItem(oauthTokenHeader: any,object_shared_uid: any,setCommentList: any) {
  try {
    const response = await actionItemsService.getComments(oauthTokenHeader,object_shared_uid);
    if (!response || !response.status || response.status !== 200) {
      setCommentList([]);
      throw new Error("Failed to get comments for specific task");
    } else {
      setCommentList(response?.data?.data);
    }
  } catch (e: any) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
}

async function getAllUserList(oauthTokenHeader: any) {
  try {
    const response = await actionItemsService.getAllUsers(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get users");
    } else {
      store.dispatch(setAllUsers(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getAllWebsites(oauthTokenHeader: any) {
  try {
    const response = await actionItemsService.getAllWebsites(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get websites");
    } else {
      store.dispatch(setAllWebsites(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function CreateNewActionItem(oauthTokenHeader: string, data: any) {
  try {
    const response = await actionItemsService.createActionItem(
      oauthTokenHeader,
      data
    );
    // Ensure response exists and check for both 200 and 201
    if (!response || !response.status) {
      return { reason: "Failed to create new task." };
    }

    if (response.status === 200) {
      return response?.data;
    } else if (response.status === 201) {
      return response?.data;
    } else {
      return { reason: `Unexpected status code: ${response.status}` };
    }
  } catch (e: any) {
    return e?.parsedText || { reason: "Unknown error occurred." };
  }
}

async function uploadFileActionItem(
  oauthTokenHeader: any,
  data: any,
  object_shared_uid: any
) {
  try {
    const response = await actionItemsService.fileUploadItem(
      oauthTokenHeader,
      data,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to upload files");
    } else {
      return response?.data?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getFilesActionItem(
  oauthTokenHeader: any,
  task_shared_uid: any,
  setFiles: any
) {
  try {
    const response = await actionItemsService.getFilesItem(
      oauthTokenHeader,
      task_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get files");
    } else {
      setFiles(response?.data?.data);
      //return response?.data?.data;
    }
  } catch (e: any) {
    // store.dispatch(
    //   setDisplayErrorSnackBar({
    //     message: e?.parsedText || "Unknown error occurred",
    //     type: "error",
    //   })
    // );

    // eslint-disable-next-line no-console
    console.error(e);
  }
}

async function getSingleActionItemData(
  oauthTokenHeader: string,
  actionItemsSharedUid: string,
  dispatch: any,
  navigate: any,
  location: any
) {
  try {
    const response = await actionItemsService.getSingleActionItem(
      oauthTokenHeader,
      actionItemsSharedUid
    );
    if (!response.status || response.status !== 200) {
      /* trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Quarterly goals', type: 'error' }))); */
    } else {
      dispatch(setSingleactionItemDetails(response?.data?.data));
    }
  } catch (e: any) {
    const existingParams = new URLSearchParams(location.search);
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
    navigate(`/tools/action_items?${existingParams.toString()}/`);
  }
}

async function updateActionItemData(
  oauthTokenHeader: any,
  data: any,
  action_item_shared_uid: any
) {
  try {
    const response = await actionItemsService.updateActionTaskData(
      oauthTokenHeader,
      data,
      action_item_shared_uid
    );

    if (!response || !response.status) {
      throw new Error("Failed to update the task. Please try again later.");
    } else if (
      response.status === 207 ||
      response.status === 201 ||
      response.status === 200
    ) {
      //store.dispatch(setDisplayErrorSnackBar({ message: "Current status has been updated", type: 'success' }))
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function putCommentsForActionItems(oauthTokenHeader: any, data: any, object_shared_uid: any) {
  try {
    const response = await actionItemsService.putComments(oauthTokenHeader, data, object_shared_uid);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to update comment");
    } else {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", })
    );
  }
}

async function deleteCommentForActionItems(oauthTokenHeader: any, objectSharedUid: any, commentId: any) {
  try {
    const response = await actionItemsService.deleteComment(oauthTokenHeader, objectSharedUid, commentId);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to delete comment");
    } else {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", })
    );
  }
}

async function deleteFileForActionItems(oauthTokenHeader: any, file_shared_uid: any) {
  try {
    const response = await actionItemsService.deleteFile(oauthTokenHeader, file_shared_uid);
    if (!response || !response.status) {
      throw new Error("Failed to delete file");
    } else if (response.status === 204) {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", })
    );
  }
}

export const ActionItemsEndPointLogic = {
  getAllActionItems,
  changeActionTaskStatus,
  commentActionItemsTask,
  getCommentsForActionItem,
  getAllUserList,
  getAllWebsites,
  CreateNewActionItem,
  uploadFileActionItem,
  getFilesActionItem,
  getSingleActionItemData,
  updateActionItemData,
  putCommentsForActionItems,
  deleteCommentForActionItems,
  deleteFileForActionItems
};
